import React from 'react';
import { useGlobal } from 'reactn';
import { Dialog } from "primereact/dialog";
import { getNombrePorID } from '../../../util/functions';

const ModalDetalles = (props) => {
    const [locaciones] = useGlobal("locacionesCompras")
    const [unidades] = useGlobal("unidadesCompras")
    const [empresas] = useGlobal("empresas")
    const [invernaderosFisicos] = useGlobal("invernaderosFisicos")

    return (
        <Dialog header={`Items del orden # ${props.detalles.orden_num}`} visible={!!props.visible} style={{ width: '50vw', overflow: "scroll" }} onHide={props.hide}>
            <div className="p-grid ">
                {props.detalles?.items?.map((item, index) => {
                    return (
                        <div key={`item-modal-${index}`} className="card item-compras w-100">
                            <div className="p-col-12">
                                <div className="p-grid">
                                    <span className="titles-group">
                                        <h1 className="header-title">
                                            {item.solicitud} ({item.cantidad} {getNombrePorID(unidades, item.unidades)})
                                        </h1>
                                        <p className="header-subtitle">
                                            {getNombrePorID(empresas, item.empresa)} - {getNombrePorID([...locaciones, ...invernaderosFisicos], item.locacion)}
                                        </p>
                                        <p className="compras-detalles-text"> {item.detalle} </p>
                                    </span>

                                </div>
                            </div>
                        </div>)
                })}
            </div>
        </Dialog >)
}
export default ModalDetalles;